var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRAddressbookDisc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-addressbook-disc",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0c11.038,0 20,8.962 20,20c0,11.038 -8.962,20 -20,20c-11.038,0 -20,-8.962 -20,-20c0,-11.038 8.962,-20 20,-20Zm5.261,10l-11.335,-0c-1.59,-0 -2.879,1.245 -2.879,2.782l0,14.436c0,1.537 1.289,2.782 2.879,2.782l11.335,-0c1.59,-0 2.879,-1.245 2.879,-2.782l-0,-14.436c-0,-1.537 -1.291,-2.782 -2.879,-2.782Zm1.44,17.218c-0,0.767 -0.646,1.391 -1.44,1.391l-11.335,-0c-0.793,-0 -1.439,-0.624 -1.439,-1.391l-0,-14.436c-0,-0.767 0.646,-1.391 1.439,-1.391l11.335,0c0.794,0 1.44,0.624 1.44,1.391l-0,14.436Zm3.598,-3.985l-0.72,-0l0,4.173l0.72,0c0.397,0 0.719,-0.311 0.719,-0.695l0,-2.783c0,-0.382 -0.323,-0.695 -0.719,-0.695Zm-5.419,0.863c-0.778,-1.28 -1.366,-1.95 -2.77,-2.5l-0.046,-0.016c1.02,-0.745 1.673,-1.916 1.673,-3.234c-0,-2.233 -1.873,-4.043 -4.183,-4.043c-2.31,0 -4.183,1.81 -4.183,4.043c0,1.318 0.653,2.489 1.663,3.227l0.01,0.007c-1.45,0.566 -2.038,1.236 -2.799,2.485l-0.017,0.031c-0.056,0.092 -0.089,0.202 -0.089,0.32c0,0.352 0.296,0.638 0.661,0.638c0.242,-0 0.455,-0.127 0.569,-0.316l0.002,-0.003c0.97,-1.601 2.156,-2.344 4.183,-2.344c2.027,0 3.213,0.743 4.169,2.319l0.014,0.025c0.116,0.192 0.328,0.319 0.571,0.319c0.365,-0 0.661,-0.286 0.661,-0.639c-0,-0.117 -0.033,-0.227 -0.091,-0.322l0.002,0.003Zm5.419,-6.427l-0.72,-0l0,4.173l0.72,-0c0.396,-0 0.719,-0.313 0.719,-0.696l0,-2.782c0,-0.382 -0.323,-0.695 -0.719,-0.695Zm-13.607,0.679c-0,-1.527 1.281,-2.766 2.862,-2.766c1.581,0 2.862,1.239 2.862,2.766c-0,1.528 -1.281,2.767 -2.862,2.767c-1.58,-0.002 -2.86,-1.24 -2.862,-2.766l-0,-0.001Zm13.607,-6.243l-0.72,-0l0,4.173l0.72,-0c0.396,-0 0.719,-0.313 0.719,-0.696l0,-2.782c0,-0.384 -0.323,-0.695 -0.719,-0.695Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRAddressbookDisc);
export default __webpack_public_path__ + "static/media/iconR-addressbook-disc.221824752143dc1d938013304b325dac.svg";
export { ForwardRef as ReactComponent };